import React from 'react'

const PsychologistPage = () => {
  return (
    <div>PsychologistPage</div>
  )
}

export default PsychologistPage